const mediaClipper = {
    en: {
      mediaClipper: {
        "timeMode": {
          "videoTime": "Video Time",
          "airTime": "Air Time",
          "switchToVideoTime": "Switch to Video Time",
          "switchToAirTime": "Switch to Air Time"
        },
        "validation": {
          "invalidAirtimeFormat": "Invalid airtime format or time outside video range. Please use HH:MM:SS",
          "invalidTimeFormat": "Invalid time format. Please use MM:SS or HH:MM:SS",
          "startBeforeEnd": "Start time must be before end time",
          "startExceedsDuration": "Start time cannot exceed video duration",
          "endAfterStart": "End time must be after start time",
          "endExceedsDuration": "End time cannot exceed video duration"
        },
        clippingMetadata:{
          start : "Start:",
          end : "End:",
          save : "Save",
          extend : "Extend",
          restore : "Restore",
          cancel : "Cancel",
          clip: 'Keep Selection',
          delete: 'Delete Selection',
          confirm_action: 'Confirm',
          missing_param: 'Missing query params. Closing window'
        },
        modal:{
          title: "Save Clipped",
          submit: "Add New Clip"
        },
        tooltips:{
          user_id: 'User ID:',
          last_edit: 'Last Edit:',
          trim_tooltip_text: "Keeps only the selected portion and discards the rest of the video",
          delete_tooltip_text: "Deletes the selected portion from the video. Once deleted, further clipping/extending actions will be disabled",
          saveDisabledOverLimit: "Cannot save: video duration exceeds the maximum limit of {maxDuration}",
        },
        form:{
          success_message: "Clip saved successfully, refreshing article page",
          success_with_sync_error: "Clip saved successfully, Insight sync failed",
          s3_upload_error: "Unexpected error while uploading asset to S3",
          save_error: "Unexpected error while saving",
          deleted_asset: 'Original asset is no longer archived'
        },
        merge: {
          extendableMediaPathNotFound: "Extendable media path not found",
          unexpectedMimeType: "Error unexpected Mime type {mimeType}",
          onlyPreviousClipsAvailable: "Only {available} previous clip(s) available (requested {requested})",
          onlyNextClipsAvailable: "Only {available} next clip(s) available (requested {requested})",
          mergeFailed: "Merge failed",
          specifyAtLeastOneClip: "Please specify at least one clip to merge",
          errorDuringMerge: "Error during merge operation",
          durationWarning: "Warning: Duration exceeds 2.5 hours. Remember you'll need to crop the final video to stay under this limit.",
          durationLimitExceeded: "Cannot merge: Duration is over the authorised limit of 3:15",
          mergeMultipleClips: "Merge Multiple Clips",
          clipsBefore: "Clips before:",
          clipsAfter: "Clips after:",
          available: "available",
          mergeButton: "Merge"
        }
      }
    }
  }
  
  module.exports.mediaClipper = mediaClipper;
  